import {onBlockLoaded} from "@plaudit/frontend-apis";

onBlockLoaded("plaudit-query-loop/reset-link", element => {
	if (element instanceof HTMLButtonElement) {
		element.addEventListener('click', () => element.dispatchEvent(new Event(element.value || "clear", {bubbles: true, cancelable: true})));
	}
});
